import React from "react";
import { withReactAdapter } from "./withReactAdapter";
type LazyOptions = {
	usesBootstrap?: boolean;
	usesMoment?: boolean;
	usesReactAdapter?: boolean;
};

function Spinner() {
	return (
		<div className="m-spinner m-spinner-wide">
			<svg className="m-spinner-svg" viewBox="25 25 50 50">
				<circle
					className="m-spinner-path"
					cx="50"
					cy="50"
					r="20"
					fill="none"
					strokeWidth="1"
					strokeMiterlimit="10"
				/>
			</svg>
		</div>
	);
}

function wrapReactLazy(Component, options: LazyOptions) {
	const BootstrapCSS = React.lazy(() => import("./BootstrapCSS"));

	const Wrapped = props => {
		if (options.usesMoment) {
			import("./Moment").then(module => module.default());
		}

		return (
			<React.Suspense fallback={<Spinner />}>
				{options.usesBootstrap && <BootstrapCSS />}
				<Component {...props} />
			</React.Suspense>
		);
	};

	Wrapped.displayName = `LazyWrapped(${Component.displayName || Component.name || "Component"})`;

	return options.usesReactAdapter ? withReactAdapter(Wrapped) : Wrapped;
}

export function wrapLazily(importFunc: () => Promise<any>, options: LazyOptions = {}): React.ComponentType<any> {
	return wrapReactLazy(React.lazy(importFunc), options);
}
